import React from "react";

const LogOut = ({ className }: { className?: string }) => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M1.77778 16C1.28889 16 0.870518 15.8261 0.522666 15.4782C0.174815 15.1304 0.000592592 14.7117 0 14.2222V1.77778C0 1.28889 0.174222 0.870518 0.522666 0.522666C0.871111 0.174815 1.28948 0.000592592 1.77778 0H7.11111C7.36296 0 7.57422 0.0853334 7.74488 0.256C7.91555 0.426666 8.00059 0.637629 7.99999 0.888888C7.9994 1.14015 7.91407 1.35141 7.74399 1.52267C7.57392 1.69392 7.36296 1.77896 7.11111 1.77778H1.77778V14.2222H7.11111C7.36296 14.2222 7.57422 14.3075 7.74488 14.4782C7.91555 14.6489 8.00059 14.8598 7.99999 15.1111C7.9994 15.3624 7.91407 15.5736 7.74399 15.7449C7.57392 15.9161 7.36296 16.0012 7.11111 16H1.77778ZM12.6 8.88888H6.22222C5.97037 8.88888 5.7594 8.80355 5.58933 8.63288C5.41926 8.46222 5.33392 8.25125 5.33333 7.99999C5.33274 7.74873 5.41807 7.53777 5.58933 7.36711C5.76059 7.19644 5.97155 7.11111 6.22222 7.11111H12.6L10.9333 5.44444C10.7704 5.28148 10.6889 5.08148 10.6889 4.84444C10.6889 4.6074 10.7704 4.4 10.9333 4.22222C11.0963 4.04444 11.3037 3.9517 11.5555 3.944C11.8074 3.93629 12.0222 4.02163 12.2 4.2L15.3778 7.37777C15.5555 7.55555 15.6444 7.76296 15.6444 7.99999C15.6444 8.23703 15.5555 8.44444 15.3778 8.62222L12.2 11.8C12.0222 11.9778 11.8113 12.0631 11.5671 12.056C11.323 12.0489 11.1117 11.9561 10.9333 11.7778C10.7704 11.6 10.6927 11.389 10.7004 11.1449C10.7081 10.9007 10.7932 10.6969 10.9555 10.5333L12.6 8.88888Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default LogOut;
